export const MENU_OPTION_HOME = {
  name: "home",
  title: "Home",
  description: "Ir para a página inicial",
  path: "/",
  icon: "home",
};

export const MENU_OPTION_WHO_WE_ARE = {
  name: "who-we-are",
  title: "Quem somos",
  description: "Saiba mais sobre a empresa",
  path: "/quem-somos",
  icon: "id_card",
};

export const MENU_OPTION_SERVICES = {
  name: "services",
  title: "Serviços",
  description: "Saiba mais sobre os serviços que oferecemos",
  path: "/servicos",
  icon: "handshake",
};

export const MENU_OPTION_TRAININGS = {
  name: "trainings",
  title: "T&D",
  description: "Saiba mais sobre os nossos programas de Treinamento e Desenvolvimento (T&D)",
  path: "/treinamentos-e-desenvolvimento-profissional",
  icon: "graduation",
};

export const MENU_OPTION_COURSES = {
  name: "courses",
  title: "Cursos",
  description: "Saiba mais sobre os nossos cursos",
  path: "/cursos-e-desenvolvimento",
  icon: "graduation",
};

export const MENU_OPTION_EVENTS = {
  name: "events",
  title: "Concursos e Processos Seletivos",
  description: "Conheça e se inscreva em nossos concursos, processos seletivos, capacitações e treinamentos",
  path: "/eventos",
  icon: "calendar",
};

export const MENU_OPTION_CONTACT = {
  name: "contact",
  title: "Contato",
  description: "Ir para a página de contato",
  path: "/contato",
  icon: "comments",
};

export const MENU_OPTION_PRIVACY_POLICY = {
  name: "privacy-policy",
  title: "Política de Privacidade",
  description:
    "Leia sobre nossa política de privacidade e como tratamos seus dados",
  path: "/politica-de-privacidade",
  icon: "info",
};

export const MENU_HEADER = [
  MENU_OPTION_HOME,
  MENU_OPTION_WHO_WE_ARE,
  MENU_OPTION_SERVICES,
  MENU_OPTION_COURSES,
  MENU_OPTION_EVENTS,
  MENU_OPTION_CONTACT,
];

export const MENU_ALL = [
  MENU_OPTION_HOME,
  MENU_OPTION_WHO_WE_ARE,
  MENU_OPTION_SERVICES,
  MENU_OPTION_COURSES,
  MENU_OPTION_EVENTS,
  MENU_OPTION_CONTACT,
];

export const MENU_FOOTER = [
  MENU_OPTION_PRIVACY_POLICY,
  MENU_OPTION_WHO_WE_ARE,
  MENU_OPTION_CONTACT,
];
